import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function CalendarIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="CalendarIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path d="M8 2v4" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 2v4" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M5 4h14s2 0 2 2v14s0 2 -2 2H5s-2 0 -2 -2V6s0 -2 2 -2"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M3 10h18" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
}
